/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { ISecurityRequirementParent } from '../../core/models/common/ISecurityRequirementParent';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { OasSecurityRequirement } from '../../openapi/models/OasSecurityRequirement';

/**
 * A command used to delete all security requirements from a document or operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllSecurityRequirementsCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldSecurityRequirements : Array<any>;

    public constructor(parent? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.ISecurityRequirementParent") >= 0)) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSecurityRequirements===undefined) this._oldSecurityRequirements = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSecurityRequirements===undefined) this._oldSecurityRequirements = null;
            (() => {
                Library.createNodePath(<Node><any>parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSecurityRequirements===undefined) this._oldSecurityRequirements = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldSecurityRequirements===undefined) this._oldSecurityRequirements = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllSecurityRequirementsCommand] Executing.");
        this._oldSecurityRequirements = <any>([]);
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let requirements : Array<SecurityRequirement> = parent.getSecurityRequirements();
        if(!this.isNullOrUndefined(requirements)) {
            requirements.forEach((req) => {
                /* add */(this._oldSecurityRequirements.push(Library.writeNode(req))>0);
            });
        }
        NodeCompat.setProperty(parent, Constants.PROP_SECURITY, null);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllSecurityRequirementsCommand] Reverting.");
        if(ModelUtils.isDefined(this._oldSecurityRequirements) && /* size */(<number>this._oldSecurityRequirements.length) === 0) {
            return;
        }
        let parent : ISecurityRequirementParent = <ISecurityRequirementParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let requirements : Array<SecurityRequirement> = parent.getSecurityRequirements();
        if(this.isNullOrUndefined(requirements)) {
            requirements = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_SECURITY, requirements);
        }
        for(let index192=0; index192 < this._oldSecurityRequirements.length; index192++) {
            let oldSecurityRequirement = this._oldSecurityRequirements[index192];
            {
                let requirement : OasSecurityRequirement = <OasSecurityRequirement>parent.createSecurityRequirement();
                Library.readNode(oldSecurityRequirement, requirement);
                /* add */(requirements.push(requirement)>0);
            }
        }
    }
}
DeleteAllSecurityRequirementsCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllSecurityRequirementsCommand";
DeleteAllSecurityRequirementsCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

